import {
  PostApiSpoSegmentationsTypesBody,
  PostApiSpoSegmentationsTypesByIdsBody,
  SpoSegmentationTypesResponse,
} from '@spo/types';
import { apiBff } from '.';

export const fetchSegmentationTypesByIds = async (
  postApiSpoSegmentationsTypesByIdsBody: PostApiSpoSegmentationsTypesByIdsBody,
): Promise<SpoSegmentationTypesResponse> =>
  apiBff.callBFF(
    'POST',
    'spo/segmentations_types_by_ids',
    postApiSpoSegmentationsTypesByIdsBody,
  );

export const fetchSegmentationTypes = async (
  postApiSpoSegmentationsTypesBody: PostApiSpoSegmentationsTypesBody,
): Promise<SpoSegmentationTypesResponse> =>
  apiBff.callBFF(
    'POST',
    'spo/segmentations_types',
    postApiSpoSegmentationsTypesBody,
  );
